var _polygon, _rect, _rect2, _rect3, _rect4, _polygon2, _rect5, _rect6, _polygon3, _polygon4, _polygon5, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 911.91 265.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 4 copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "269.68 196.37 269.54 238.87 400.86 239.28 401 196.79 315.71 196.52 269.68 196.37"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 824.74,
    y: 172.78,
    width: 42.49,
    height: 93.34,
    transform: "translate(623.84 1064.73) rotate(-89.82)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 402.95,
    y: 59.74,
    width: 104.47,
    height: 46.04,
    transform: "translate(370.98 537.68) rotate(-89.82)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 402.62,
    y: 164.2,
    width: 104.47,
    height: 46.04,
    transform: "translate(266.19 641.48) rotate(-89.82)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 209.74,
    y: 90.21,
    width: 166.44,
    height: 46.04,
    transform: "matrix(0, -1, 1, 0, 178.8, 405.82)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "558.29 30.85 509.37 30.7 591 239.89 591 239.89 639.92 240.04 558.29 30.85"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 822.42,
    y: 90.37,
    width: 42.49,
    height: 88.16,
    transform: "matrix(0, -1, 1, 0, 706.53, 977.69)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 825.26,
    y: 6.35,
    width: 42.49,
    height: 93.34,
    transform: "translate(790.81 899.35) rotate(-89.82)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "753.88 31.47 753.62 112.92 799.65 113.07 799.77 74.11 799.91 31.62 753.88 31.47"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "753.21 240.4 799.25 240.55 799.38 198.06 799.52 155.56 799.65 113.07 753.62 112.92 753.21 240.4"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "650.78 212.47 722.88 31.11 673.95 30.96 626.5 150.32 650.78 212.47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.35,172.09a65.86,65.86,0,0,1,91.88-91.88L198.5,48.94A109.75,109.75,0,0,0,44.07,203.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.93,96.33A65.86,65.86,0,0,1,91.23,188L59.88,219.37A109.75,109.75,0,0,0,214.28,65Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7e926538e0aee94261bc5bed8f829f85.svg";
export { ForwardRef as ReactComponent };